import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_REEFER_DATA:
      return { ...action.reeferData };
    default: return state;
  }
};
